const getProjectListBySearchReq = {
  actionType: '',
  customerKey: '',
  projectId: '',
  approvedBy: '',
  fromStartDate: '',
  fromEndDate: '',
  endEndDate: '',
  isActive: true,
  isApproved: true,
  pageSize: 10,
  pageNo: 1,
  //sortASC: true,
};

export default getProjectListBySearchReq;
